import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Home from "../home/Home";
import App from "../../App";
import UserLayout from "../user/userLayout/UserLayout";
import Dashboard from "../user/dashboard/Dashboard";
import Signin from "../user/auth/signin/Signin";
import Signup from "../user/auth/signup/Signup";

//admin
import AdminLayout from "../admin/adminLayout/AdminLayout";
import AdminDashboard from "../admin/adminDashboard/AdminDashboard";

import Csos from "../admin/cso/Csos";
import EachCso from "../admin/cso/each/EachCso";
import Users from "../admin/users/Users";

import EditProfile from "../admin/profile/EditProfile";
import ViewProfile from "../admin/profile/ViewProfile";
import ChangePassowrd from "../admin/changePassword/ChangePassowrd";

import News from "../news/News";
import Abouts from "../about/Abouts";
import Meeting from "../admin/webContent/meeting/Meeting";
import AddMeeting from "../admin/webContent/meeting/AddMeeting";
import EditMeeting from "../admin/webContent/meeting/EditMeeting";
import ViewMeeting from "../admin/webContent/meeting/ViewMeeting";
import Contact from "../contact/Contact";
import Service from "../service/Service";
import CsoRegister from "../admin/cso/csoList/CsoRegister";
import CreateAccount from "../admin/createAccount/CreateAccount";
import PrivateRoute from "../privateRoute/PrivateRoute ";
import EditUserProfile from "../user/profile/EditUserProfile";
import ViewUserProfile from "../user/profile/ViewUserProfile";
import ShowReport from "../admin/cso/reports/ShowReport";
import CSOProfile from "../admin/cso/cosProfile/CSOProfile";
import Unauthorized from "../unauthorized/Unauthorized";
import EditUserPassword from "../user/password/EditUserPassword";
import ForgotPassword from "../user/auth/forgotPassword/ForgotPassword";
import ResetPassword from "../user/auth/resetPassword/ResetPassword";
import CSOLists from "../admin/cso/csoList/CSOLists";
import EditCSO from "../admin/cso/csoList/EditCSO";
import StaffRegister from "../admin/staff/StaffRegister";
import BeneficiaryList from "../admin/beneficiary/BeneficiaryList";
import ViewBeneficiary from "../admin/beneficiary/ViewBeneficiary";
import EditBeneficiary from "../admin/beneficiary/EditBeneficiary";
import AddBeneficiary from "../admin/beneficiary/AddBeneficiary";
import Notifications from "../user/notifications/Notifications";
import Notification from "../admin/notifications/Notifications";
import CreateProjectProposal from "../admin/file/CreateProjectProposal";
import ListProjectProposal from "../admin/file/ListProjectProposal";
import ViewProject from "../admin/file/ViewProject";
import EditProject from "../admin/file/EditProject";
import StaffRegistration from "../admin/auth/StaffRegistration";
import EmailVerification from "../admin/auth/EmailVerification";
import Login from "../admin/auth/Login";
import ForgotPasswordStaff from "../admin/auth/ForgotPassword";
import ResetPasswordStaff from "../admin/auth/ResetPassword";
import LetterManagement from "../letterManagement/LetterManagement";
import SubmissionForm from "../user/form/SubmissionForm";
import FormList from "../user/form/FormList";
// import FormEditor from "../user/form/FormEditor";
import ViewForm from "../admin/form/ViewForm";
import CreateForm from "../admin/form/CreateForm";
import EditForm from "../admin/form/EditForm";
import Forms from "../admin/form/Forms";
import Submitted from "../user/submission/Submitted";
import ViewSubmission from "../user/submission/ViewSubmission";
import AllSubmission from "../admin/cso/csoSubmission/AllSubmission";
import ViewSubmitted from "../admin/cso/csoSubmission/ViewSubmitted";
import CsoSubmission from "../admin/cso/csoSubmission/CsoSubmission";
import LetterForm from "../admin/letter/LetterForm";
import CSOLettersView from "../user/letter/CSOLettersView";
import LetterList from "../admin/letter/LetterList";
import LetterView from "../admin/letter/LetterView";
import LetterEdit from "../admin/letter/LetterEdit";
import StaffList from "../admin/staff/StaffList";
import StaffView from "../admin/staff/StaffView";
import StaffEdit from "../admin/staff/StaffEdit";
import LetterDetail from "../user/letter/LetterDetail";
import CreateContact from "../admin/webContent/contact/CreateContact";
import Backup from "../admin/backup/Backup";
import NewsDetails from "../news/NewsDetails";
import CreateNews from "../admin/webContent/news/CreateNews";
import NewsList from "../admin/webContent/news/NewsList";
import EditNews from "../admin/webContent/news/EditNews";
import ViewNews from "../admin/webContent/news/ViewNews";
import UpdateAbout from "../admin/webContent/aboutContent/UpdateAbout";
import HeroSlideList from "../admin/webContent/hero/HeroSlideList";
import CreateHeroSlide from "../admin/webContent/hero/CreateHeroSlide";
import ViewHeroSlide from "../admin/webContent/hero/ViewHeroSlide";
import UpdateHeroSlide from "../admin/webContent/hero/UpdateHeroSlide";
import ServiceManager from "../admin/webContent/serviceContent/ServiceManager";
import LettersPortal from "../portal/LettersPortal";
import Doc_Guideline from "../doc_guideline/Doc_Guideline";
import DocGuideline from "../admin/webContent/docGuideline/DocGuideline";
import CreateDoc from "../admin/webContent/docGuideline/CreateDoc";
import EditDoc from "../admin/webContent/docGuideline/EditDoc";
import ViewDoc from "../admin/webContent/docGuideline/ViewDoc";
import ViewRequest from "../user/requests/ViewRequest";
import ListRequest from "../user/requests/ListRequest";
import CreateRequest from "../user/requests/CreateRequest";
import EditRequest from "../user/requests/EditRequest";
import ListRequests from "../admin/cso/request/ListRequests";
import ViewRequests from "../admin/cso/request/ViewRequests";
import ListFAQ from "../admin/FAQ/ListFAQ";
import CreateFAQ from "../admin/FAQ/CreateFAQ";
import EditFAQ from "../admin/FAQ/EditFAQ";
import Chat from "../user/chat/Chat";
import Chats from "../admin/chats/Chats";
import BeneficiaryTrace from "../user/BeneficiaryTrace/BeneficiaryTrace";

const Routers = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/news",
        element: <News />,
      },

      {
        path: "/news/details/:id",
        element: <NewsDetails />,
      },
      {
        path: "/services",
        element: <Service />,
      },
      {
        path: "/about",
        element: <Abouts />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/portal",
        element: <LettersPortal />,
      },
      {
        path: "/doc",
        element: <Doc_Guideline />,
      },
      {
        path: "/user/login",
        element: <Signin />,
      },
      {
        path: "/user/signup",
        element: <Signup />,
      },
    ],
  },
  //User Dashboard
  {
    path: "/user",
    element: <PrivateRoute element={<UserLayout />} roleRequired="cso" />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "requests",
        element: <ListRequest />,
      },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "view_request/:id",
        element: <ViewRequest />,
      },

      {
        path: "unauthorized",
        element: <Unauthorized />,
      },
      {
        path: "create_request",
        element: <CreateRequest />,
      },
      {
        path: "update_request/:id",
        element: <EditRequest />,
      },
      {
        path: "Edit_user_prifile",
        element: <EditUserProfile />,
      },
      {
        path: "view_user_prifile",
        element: <ViewUserProfile />,
      },
      {
        path: "edit_user_password",
        element: <EditUserPassword />,
      },
      {
        path: "notifications",
        element: <Notifications />,
      },
      {
        path: "form",
        element: <FormList />,
      },
      {
        path: "form/:id",
        element: <SubmissionForm />,
      },
      {
        path: "form/edit/:id",
        element: <EditForm />,
      },
      {
        path: "form/view/:id",
        element: <ViewForm />,
      },
      {
        path: "submitted",
        element: <Submitted />,
      },
      {
        path: "view_submitted/:id",
        element: <ViewSubmission />,
      },
      {
        path: "letters_list",
        element: <CSOLettersView />,
      },
      {
        path: "letters_detail/:id",
        element: <LetterDetail />,
      },
       {
        path: "beneficiary_trace",
        element: <BeneficiaryTrace />,
      },
    ],
  },
  // admin dashboard
  {
    path: "/admin",
    element: (
      <PrivateRoute
        roleRequired={["admin", "sup_admin"]}
        element={<AdminLayout />}
      />
    ),
    children: [
      {
        path: "dashboard",
        element: <AdminDashboard />,
      },
      // {
      //   path: "report_category",
      //   element: <Category />,
      // },
     
       {
        path: "chats",
        element: <Chats />,
      },
      {
        path: "all_cso",
        element: <Csos />,
      },
      {
        path: "each_cso/:id",
        element: <EachCso />,
      },
      {
        path: "list_requests",
        element: <ListRequests />,
      },
      {
        path: "cso_view_requests/:id",
        element: <ViewRequests />,
      },
      {
        path: "faq",
        element: <ListFAQ />,
      },
      {
        path: "create_faq",
        element: <CreateFAQ />,
      },
      {
        path: "edit_faq/:id",
        element: <EditFAQ />,
      },
      {
        path: "show_report/:id",
        element: <ShowReport />,
        loader: async ({ params }) =>
          fetch(
            `${process.env.REACT_APP_API_URL}/api/report/view/byId/${params.id}`
          ).then((res) => res.json()),
      },
      {
        path: "users",
        element: <Users />,
      },
      // {
      //   path: "report_category/category",
      //   element: <UploadCategory />,
      // },
      // {
      //   path: "report_category/edit_category/:id",
      //   element: <EditCategory />,
      // },
      // {
      //   path: "report_category/all_cso_reports",
      //   element: <AllCsoReports />,
      // },
      {
        path: "edit_profile",
        element: <EditProfile />,
      },
      {
        path: "view_profile",
        element: <ViewProfile />,
      },
      {
        path: "update_password",
        element: <ChangePassowrd />,
      },
      {
        path: "cso_profile/:id",
        element: <CSOProfile />,
      },

      {
        path: "web_content/meeting_content",
        element: <Meeting />,
      },
      {
        path: "web_content/add_meeting_content",
        element: <AddMeeting />,
      },
      {
        path: "web_content/update_meeting_content",
        element: <EditMeeting />,
      },
      {
        path: "web_content/view_meeting_content",
        element: <ViewMeeting />,
      },
      {
        path: "user_register",
        element: <CsoRegister />,
      },
      {
        path: "staff_register",
        element: (
          <PrivateRoute
            roleRequired={["sup_admin"]}
            element={<StaffRegister />}
          />
        ),
      },
      {
        path: "staffs",
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<StaffList />} />
        ),
      },
      {
        path: "staffs/view/:id",
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<StaffView />} />
        ),
      },
      {
        path: "staffs/edit/:id",
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<StaffEdit />} />
        ),
      },
      {
        path: "users/create_account",
        element: <CreateAccount />,
      },
      {
        path: "cso_list",
        element: <CSOLists />,
      },
      {
        path: "cso_edit/:id",
        element: <EditCSO />,
      },

      {
        path: "beneficiary_list",
        element: <BeneficiaryList />,
      },

      {
        path: "view_beneficiary/:id",
        element: <ViewBeneficiary />,
      },
      {
        path: "edit_beneficiary/:id",
        element: <EditBeneficiary />,
      },
      {
        path: "add_beneficiary",
        element: <AddBeneficiary />,
      },
      {
        path: "notifications",
        element: <Notification />,
      },
      {
        path: "project",
        element: <CreateProjectProposal />,
      },
      {
        path: "listPP",
        element: <ListProjectProposal />,
      },
      {
        path: "view/:id",
        element: <ViewProject />,
      },
      {
        path: "edit/:id",
        element: <EditProject />,
      },
      {
        path: "letter",
        element: <LetterManagement />,
      },
      //form
      {
        path: "create_form",
        element: <CreateForm />,
      },
      {
        path: "edit_form/:id",
        element: <EditForm />,
      },
      {
        path: "view_form/:id",
        element: <ViewForm />,
      },
      {
        path: "forms",
        element: <Forms />,
      },
      {
        path: "all_submission",
        element: <AllSubmission />,
      },
      {
        path: "view_submission/:id",
        element: <ViewSubmitted />,
      },
      {
        path: "cso_submission/:id",
        element: <CsoSubmission />,
      },
      {
        path: "letter_form",
        element: <LetterForm />,
      },
      {
        path: "letter_list",
        element: <LetterList />,
      },
      {
        path: "letter_view/:id",
        element: <LetterView />,
      },
      {
        path: "letter_edit/:id",
        element: <LetterEdit />,
      },
      {
        path: "backup",
        element: <Backup />,
      },
      // web content

      {
        path: "create_contact_info",
         element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<CreateContact />} />
        ),
      },
      {
        path: "news",
         element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<CreateNews />} />
        ),
      },
      {
        path: "news_list",
        // element: <NewsList />,
          element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<NewsList />} />
        ),
      },
      {
        path: "edit_news/:id",
        // element: <EditNews />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<EditNews />} />
        ),
      },
      {
        path: "view_news/:id",
        // element: <ViewNews />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<ViewNews />} />
        ),
      },
      {
        path: "about_content",
        // element: <UpdateAbout />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<UpdateAbout />} />
        ),
      },
      {
        path: "hero",
        // element: <HeroSlideList />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<HeroSlideList />} />
        ),
      },
      {
        path: "create_hero",
        // element: <CreateHeroSlide />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<CreateHeroSlide />} />
        ),
      },
      {
        path: "view_hero/:id",
        // element: <ViewHeroSlide />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<ViewHeroSlide />} />
        ),
      },
      {
        path: "edit_hero/:id",
        // element: <UpdateHeroSlide />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<UpdateHeroSlide />} />
        ),
      },

      {
        path: "service",
        // element: <ServiceManager />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<ServiceManager />} />
        ),
      },
      {
        path: "doc",
        // element: <DocGuideline />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<DocGuideline />} />
        ),
      },
      {
        path: "createdoc",
        // element: <CreateDoc />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<CreateDoc />} />
        ),
      },
      {
        path: "editdoc/:id",
        // element: <EditDoc />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<EditDoc />} />
        ),
      },
      {
        path: "viewdoc/:id",
        // element: <ViewDoc />,
        element: (
          <PrivateRoute roleRequired={["sup_admin"]} element={<ViewDoc />} />
        ),
      },
    ],
  },
  //login rout
  // {
  //   path: "/user/login",
  //   element: <Signin />,
  // },
  // {
  //   path: "/user/signup",
  //   element: <Signup />,
  // },

  {
    path: "forgot_password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPassword />,
  },
  // //register rout
  {
    path: "/staff/register",
    element: <StaffRegistration />,
  },
  {
    path: "/verify/:token",
    element: <EmailVerification />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgetPassword",
    element: <ForgotPasswordStaff />,
  },
  {
    path: "/resetPassword/:token",
    element: <ResetPasswordStaff />,
  },
  {
    path: "create_userAccount",
    element: <CreateAccount />,
  },
]);
export default Routers;
